import React from 'react'

import { useFormatMessage } from '@babylon/intl'
import { Button, ModalContent, useModalActions } from '@babylon/medkit'
import { trackTealiumEvent } from '@/tracking'

import styles from './LogOut.module.scss'
import messages from './messages'
import { useConfig } from '@/redux/partnerConfig/selectors'
import { URL_PREFIX } from '@/constants'

const LogOutModal = () => {
  const { closeModal } = useModalActions()
  const translate = useFormatMessage()
  const { partnerUrlSlug } = useConfig()
  const rootUrl = `/${URL_PREFIX}/${partnerUrlSlug}`

  return (
    <ModalContent
      title={translate(messages.logOutModalTitle)}
      className={styles.logOutModal}
    >
      <div>
        <text>{translate(messages.logOutModalBody)}</text>
      </div>
      <div className={styles.logOutModal__btn__container}>
        <Button
          to={`${rootUrl}/logout`}
          onClick={() =>
            trackTealiumEvent({
              eventAction: 'clicked logout button',
              eventCategory: 'signup',
              screen_title: 'signup',
              tealium_event: 'clicked logout button',
            })
          }
          className={styles.logOutModal__rightContent__logoutLink}
        >
          {translate(messages.logOutBtn)}
        </Button>
        <Button onClick={() => closeModal()}>
          {translate(messages.cancelBtn)}
        </Button>
      </div>
    </ModalContent>
  )
}

export default LogOutModal
